import React from "react";
import style from "./EventDetailsLocation.module.css";

const EventDetailsLocation = ({ data }: any) => {
  const eventLocation = data;

  // Use the embed URL directly
  const embedUrl = eventLocation?.url || "";

  const handleMapClick = () => {
    if (eventLocation?.url) {
      // Extract coordinates from embed URL (if present)
      const coordinatesMatch = embedUrl.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
      if (coordinatesMatch) {
        const [, lat, lng] = coordinatesMatch;
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
          "_blank"
        );
      } else {
        // Fallback: open the Maps location page (not embed)
        const placeMatch = embedUrl.match(/!2s([^!]+)!/);
        if (placeMatch) {
          const placeName = decodeURIComponent(
            placeMatch[1].replace(/\+/g, " ")
          );
          window.open(
            `https://www.google.com/maps/search/?api=1&query=${placeName}`,
            "_blank"
          );
        } else {
          // If all fails, open Google Maps home
          window.open("https://www.google.com/maps", "_blank");
        }
      }
    }
  };

  return (
    <>
      {embedUrl && (
        <div className={style.detailsMap}>
          <div className="container">
            <div className={style.locationContainer}>
              <h2>{eventLocation.label}</h2>

              <div onClick={handleMapClick} style={{ cursor: "pointer" }}>
                <iframe
                  className="mt-4"
                  width="100%"
                  height="400"
                  src={embedUrl}
                  scrolling="no"
                  style={{ pointerEvents: "none" }}
                  title="Event Location Map"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventDetailsLocation;
